import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { errorMessage } from "../../api/errorMessage";
import { useActiveCompanyId } from "../../api/useActiveCompanyId";
import { MenuHeader } from "../Dashboard/block/MenuHeader/MenuHeader";
import { MobileMenu } from "../Dashboard/MobileMenu";
import "./business.scss";

export function BusinessPage({ title, subtitle, children, className = "" }: { title: string; subtitle: string; children: React.ReactNode; className?: string }) {
    const [menu, setMenu] = useState(false);
    return <><MenuHeader onMenuClick={() => setMenu(true)} /><MobileMenu open={menu} onClose={() => setMenu(false)} />
        <main className={`business-page ${className}`}><Link className="business-back" to="/">← Главная</Link><h1>{title}</h1><p className="business-subtitle">{subtitle}</p>{children}</main></>;
}

export function useCompanyResource<T>(path: string, query: Record<string, unknown> = {}) {
    const { value: companyId, resolved } = useActiveCompanyId();
    const queryKey = JSON.stringify(query);
    const key = `${companyId}:${path}:${queryKey}`;
    const [snapshot, setSnapshot] = useState<{ key: string; data: T } | null>(null);
    const [failure, setFailure] = useState<{ key: string; message: string } | null>(null);
    const [loading, setLoading] = useState(true);
    const [revision, setRevision] = useState(0);
    useEffect(() => {
        if (!resolved || !companyId) { setLoading(false); return; }
        const controller = new AbortController();
        setLoading(true); setFailure(null);
        api.get<T>(path, JSON.parse(queryKey), { signal: controller.signal, timeout: 120000 })
            .then(data => { if (!controller.signal.aborted) setSnapshot({ key, data }); })
            .catch(error => { if (!controller.signal.aborted) { setSnapshot(null); setFailure({ key, message: errorMessage(error) }); } })
            .finally(() => { if (!controller.signal.aborted) setLoading(false); });
        return () => controller.abort();
    }, [companyId, resolved, path, queryKey, key, revision]);
    return { companyId, data: snapshot?.key === key ? snapshot.data : null, error: failure?.key === key ? failure.message : null,
        loading: !resolved || loading, reload: () => setRevision(value => value + 1) };
}

export function ResourceState({ resource }: { resource: { loading: boolean; companyId: string | null; error: string | null; reload: () => void } }) {
    if (resource.error) return <div className="business-error" role="alert">{resource.error} <button onClick={resource.reload}>Повторить</button></div>;
    if (resource.loading) return <p role="status">Загружаем данные…</p>;
    if (!resource.companyId) return <p>Выберите салон в верхней части страницы.</p>;
    return null;
}

export const money = (value: number | null | undefined) => value == null ? "—" : new Intl.NumberFormat("ru-RU", { maximumFractionDigits: 0 }).format(value) + " ₽";
export const percent = (value: number | null | undefined) => value == null ? "—" : value.toLocaleString("ru-RU", { maximumFractionDigits: 1 }) + "%";
export function today() { const date = new Date(); return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`; }

export function Metric({ label, value, hint }: { label: string; value: React.ReactNode; hint?: React.ReactNode }) {
    return <section className="business-metric"><span>{label}</span><strong>{value}</strong>{hint != null && <small>{hint}</small>}</section>;
}
